import { JSONClient, FormClient } from "./bootstrap";

export const login = async (email, password, rememberMe) => {
  const response = await JSONClient.post("/auth/login", {
    userEmail: email,
    userPassword: password,
    rememberMe: rememberMe,
  });
  return response;
};

export const register = async (email, password, rememberMe, token, rcode) => {
  if(token == undefined){
    token = ""
  }
  const response = await JSONClient.post("/auth/register", {
    userEmail: email,
    userPassword: password,
    rememberMe: rememberMe,
    token: token,
    referralCode: rcode
  });
  return response;
};


export const forgotPassword = async (email) => {
  const response = await JSONClient.post('/auth/forgot-password', {
    email: email
  })

  return response
}


export const resetPassword = async (tok, password) => {
  const response = await JSONClient.post(`/auth/reset/password?${tok}`, {
    newPassword: password
  })

  return response
}


export const oAuthDiscord = async (code) => {
  const response = await JSONClient.get(`/auth/register/oauth/discord/callback?${code}`)
  return response
}

export const oAuthDiscordLogin = async (code) => {
  const response = await JSONClient.get(`/auth/login/oauth/discord/callback?${code}`)
  return response
}

export const oAuthGoogle = async(code)=>{
  const response = await JSONClient.get(`/auth/register/oauth/google/callback?${code}`)
  return response
}

export const oAuthGoogleLogin = async(code)=>{
  const response = await JSONClient.get(`/auth/login/oauth/google/callback?${code}`)
  return response
}

export const getAuthIpParams = async(token)=>{
  const response = await JSONClient.get(`/auth/fe/authorizeIP?${token}`)
  return response;
}

export const authorizeIP = async(token) => {
  const response = await JSONClient.post(`/auth/authorizeIP?${token}`)
  return response;
}

export const verifyEmail = async (token) => {
  const response = await JSONClient.post(`/auth/verify?${token}`)
  return response;
}

export const getUser = async (token, email) => {
  const response = await JSONClient.get(`/auth/user?email=${email}`, {
    headers: {
      Authorization: `Bearer ${token}`,    },
  });
  return response;
};

export const uploadProfilePicture = async function (token, fileImage) {
  let formData = new FormData();
  formData.append("file[]", fileImage);
  const response = await FormClient.put(
    "/settings/update/profile/picture",
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );
  return response.data;
};

export const getProfilePicture = async function (token, email) {
  const response = await JSONClient.get(`/settings/profile/picture/${email}`, {
    headers: {
      Authorization: `Bearer ${token}`,    },
  });
  return response;
};

export const getProxySettings = async (token) => {
  const response = await JSONClient.get("/settings/proxy-settings", {
    headers: {
      Authorization: `Bearer ${token}`,    },
  });
  return response;
};

export const updateProxySettings = async (token, filter, resovlved) => {
  const response = await JSONClient.put(
    "/settings/update/proxy-settings",
    {
      filterProxies: filter,
      resolvedProxies: resovlved,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );
  return response;
};

export const getSecurityScore = async (token) => {
  const response = await JSONClient.get("/settings/security-value", {
    headers: {
      Authorization: `Bearer ${token}`,    },
  });
  return response;
};

export const getPreferredQueue = async (token) => {
  const response = await JSONClient.get("/settings/preffered-queue ", {
    headers: {
      Authorization: `Bearer ${token}`,    },
  });
  return response;
};

export const updateProfileSettings = async (token, data) => {
  const response = await JSONClient.put(
    "/settings/update/settings",
    { ...data },
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );
  return response;
};

export const getTwo2fa = async (token) => {
  const response = await JSONClient.get("/auth/get-2fa-totp", {
    headers: {
      Authorization: `Bearer ${token}`,    },
  });
  return response;
};

export const verifyOTP = async (token, otp) => {
  const response = await JSONClient.post(
    "/auth/verify-otp",
    {
      otp: otp,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );
  return response;
};

export const cancel2fa = async (token) => {
  const response = await JSONClient.post(
    "/auth/remove-2fa",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );
  return response;
};

export const updateApiKey = async (token) => {
  const response = await JSONClient.put(
    "/settings/update/apiKey",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );
  return response;
};

export const getAccessLogs = async (token, page) => {
  const response = await JSONClient.post(
    `/settings/access-history/${page}`,
    {
      limit: 8,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );

  return response;
};

export const getApiRequestHistory = async (token, page) => {
  const response = await JSONClient.post(
    `/settings/table/request-history/${page}`,
    {
      limit: 8,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );

  return response
};

export const getNotifications = async (token) => {
  const response = await JSONClient.post(
    `/home/notifications`,
    {
      limit: 8,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    }
  );

  return response
};

export const deleteAllNotifications = async (token) => {
  const response = await JSONClient.post('/home/delete-all-notifications',{},
    {
      headers: {
        Authorization: `Bearer ${token}`,      },
    })
  return response
}

export const deleteNotificationById = async (token, id) => {
  const response = await JSONClient.post(`/home/delete-notification`, {
    id: id
  }, {
    headers: {
      Authorization: `Bearer ${token}`,    },
  })

  return response
}


export const getIPRestrictionStatus = async (token) => {
  const response = await JSONClient.get('/settings/ip-restriction', {
    headers: {
      Authorization: `Bearer ${token}`,    }
  })
  return response
}


export const updateIPRestrictionStatus = async (token, status) => {
  const response = await JSONClient.put('/settings/update/ip-restriction', {
    ipRestriction: status
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  })
  return response
}

export const getActiveSessions = async (token) => {
  const response = await JSONClient.get('/settings/browser/sessions', {
    headers: {
      Authorization: `Bearer ${token}`,    }
  })
  return response
}


export const deleteActiveSessions = async (token) => {
  const response = await JSONClient.post('/settings/delete/browser/sessions', {
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  })
  return response
}
